import {
  InRepairPhaseCompleteIcon,
  InRepairPhaseActiveIcon,
  InRepairPhasePendingIcon,
} from "../../../../../components/svg";
import { RO_DETAIL_PHASE_HISTORY_ICON } from "../../data/inRepairRoDetailConstants";

const RoDetailPhaseHistoryIcon = ({ status }) => {
  if (status === "completed") {
    return (
      <InRepairPhaseCompleteIcon
        width="15"
        height="15"
        strokeColor={RO_DETAIL_PHASE_HISTORY_ICON.completed.stroke}
      />
    );
  }
  if (status === "active") {
    return (
      <InRepairPhaseActiveIcon
        width="15"
        height="15"
        strokeColor={RO_DETAIL_PHASE_HISTORY_ICON.active.stroke}
      />
    );
  }
  return (
    <InRepairPhasePendingIcon
      width="14"
      height="14"
      strokeColor={RO_DETAIL_PHASE_HISTORY_ICON.pending.stroke}
    />
  );
};

export default RoDetailPhaseHistoryIcon;
